import { decryptData } from "../components/const";
import DbComptable from "../Comptability/DbComptable";
import DbAgent from "../CompteAgent/DbAgent";
import DbMagasin from "../Magasins/DbMagasin";
import DbAdmin from "./dbAdmin";

const Dashboard = () => {
    const user = decryptData('USER');
    return (
        <>
            {user.droit === 'Administrateur' && <DbAdmin />}
            {user.droit === 'Magasin' && <DbMagasin />}
            {user.droit === 'Comptable' && <DbComptable />}
            {user.droit === 'Agent' && <DbAgent />}
        </>

    );
}

export default Dashboard;